import { useEventLogger, useNavigationHelper } from 'FrontRoyalAngular';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';
import { AudioVisualizerPresentation } from 'TutorBotVoiceAgent/components/AudioVisualizer';
import { ImportantCtaBox } from '../ImportantCtaBox';

export function CoachingBox() {
    const { loadRoute } = useNavigationHelper();
    const EventLogger = useEventLogger();

    const onPressCta = useCallback(() => {
        EventLogger.log('student_dashboard_sidebar_box:clicked_button', {
            type: 'coaching_box:button_start_session',
        });
        loadRoute('/coach');
    }, [loadRoute, EventLogger]);

    const visualizer = useMemo(
        () => (
            <AudioVisualizerPresentation
                color="purple"
                size="xs"
                getAgentAudioData={() => ({ agentAmplitude: 0, agentFrequencyData: null })}
                getUserAudioData={() => ({ userAmplitude: 0, userFrequencyData: null })}
            />
        ),
        [],
    );

    return <CoachingBoxPresentation onPressCta={onPressCta} visualizer={visualizer} />;
}

type PresentationProps = {
    onPressCta: () => void;
    visualizer: React.ReactNode;
};

export function CoachingBoxPresentation({ onPressCta, visualizer }: PresentationProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'coachingBox.coachingBox' });

    return (
        <ImportantCtaBox
            testId="coaching-box"
            icon={visualizer}
            color="purple"
            headerSubtitle={t('subtitle')}
            headerTitle={t('title')}
            ctaText={t('ctaText')}
            onPressCta={onPressCta}
        >
            <Text as="p" color="black" weight="normal" className="text-base">
                {t('description')}
            </Text>
        </ImportantCtaBox>
    );
}
